module.exports = __webpack_public_path__ + "static/media/hazard-infographic.627d83f6.png";